import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';

import { AuthenticationService, UserBeanService, i18nService } from '@services';

export const loginResolver: ResolveFn<void> = async () => {
  const authenticationService = inject(AuthenticationService);
  const userBeanService = inject(UserBeanService);
  const i18n = inject(i18nService);

  try {
    i18n.getLocale(await authenticationService.getSystemSettings());
  } catch {}

  try {
    await userBeanService.getUserBean();
  } catch {}
};
